import { filter, isNaN, isNumber, isNil, map, sumBy } from 'lodash';
import { makeLabel } from '../../common/components/MappedLabel/MappedLabel';

export const getJunctionEnergySplitData = (data) => {
  if (!data || !data.energySplitData) {
    return [];
  }

  const ENERGY_SPLIT_NAMES = {
    grid: 'Grid',
    charger: 'Charger',
    renewable: 'Renewable',
    storage: 'Storage',
  };

  const energySplitData = filter(
    map(ENERGY_SPLIT_NAMES, (description, propertyName) => ({ name: description, value: Math.abs(data.energySplitData[propertyName]) })),
    (item) => isNumber(item.value) && !isNaN(item.value),
  );
  const energySplitDataSum = sumBy(energySplitData, 'value');

  if (energySplitDataSum > 0) {
    return energySplitData;
  }

  return [];
};

export const PLAZA_TEMPLATE_TYPES = {
  DemandBased: 'DEMAND_BASED',
  CurrentBased: 'CURRENT_BASED',
  ToUBased: 'TO_U_BASED',
  AdaptiveLoadManagement: 'ADAPTIVE_LOAD_MANAGEMENT',
};

export const DEFAULT_ALGORITHMS = {
  Custom: {
    value: 'custom',
    label: 'Custom',
  },
  Default: {
    value: 'default',
    label: 'Default',
  },
};

export const greenGrassControllerName = 'IoT.ON™ Edge Controller';

export const DEFAULT_CONFIGURATIONS = {
  Cloud: {
    value: false,
    label: 'Cloud only mode',
  },
  Edge: {
    value: true,
    label: `With ${greenGrassControllerName}`,
  },
};

export const getPlazaAlgorithmOptions = (uiLabels, plazaTemplates = []) =>
  plazaTemplates.map((option, i) => ({
    value: option.template_id,
    label: makeLabel(uiLabels, `plaza.template.${option.template_type}`, option.description),
  }));

export const convertChargerPhaseValues = (val) => {
  if (isNil(val)) {
    return null;
  }

  return val / 1000;
};

export const convertSessionEnergyValue = (val) => {
  if (isNil(val)) {
    return null;
  }

  return val / 1000 / 3600;
};
